
import { GongVolume, RestDoneVolume, Rounds, RoundTime, RestTime } from '@/entities/Property'

export default class Properties

  # properties Property

  constructor: (@properties) ->

  get: -> @properties

  clone: -> new Properties @properties.map (property) -> property.clone()

  _each: (callable) ->
    @get().forEach (property) -> callable property
    @

  _getPropertyValue: (name) ->
    properties = @get().filter (property) -> name == property.getName()
    a properties.length == 1
    return properties[0].getValue()

  getRoundTime:      -> @_getPropertyValue RoundTime
  getRestTime:       -> @_getPropertyValue RestTime
  getRounds:         -> @_getPropertyValue Rounds
  getGongVolume:     -> @_getPropertyValue GongVolume
  getRestDoneVolume: -> @_getPropertyValue RestDoneVolume

  save: -> @_each (property) -> property.save()

  load: -> @_each (property) -> property.load()

